import Vue from 'vue'
import Icon from '@/components/elements/Icon.vue'
import Dropdown from '@/components/elements/Dropdown.vue'
import Input from '@/components/elements/Input.vue'
Vue.component('dropdown', Dropdown)
Vue.component('icon', Icon)
Vue.component('pd-input', Input)
